import { AgentAvailabilityStatus } from '../interfaces/calls';

export const AGENT_STATUS_COLORS: Record<AgentAvailabilityStatus, string> = {
  [AgentAvailabilityStatus.AVAILABLE]: '#4CAF50',
  [AgentAvailabilityStatus.AWAY]: '#FFC107',
  [AgentAvailabilityStatus.DO_NOT_DISTURB]: '#F44336',
  [AgentAvailabilityStatus.OFFLINE]: '#9E9E9E',
  [AgentAvailabilityStatus.ON_CALL]: '#FF9800',
  [AgentAvailabilityStatus.DISABLED]: '#9E9E9E',
};

export const AGENT_STATUS_DISPLAY: Record<AgentAvailabilityStatus, string> = {
  [AgentAvailabilityStatus.AVAILABLE]: 'Available',
  [AgentAvailabilityStatus.AWAY]: 'Away',
  [AgentAvailabilityStatus.DO_NOT_DISTURB]: 'Do Not Disturb',
  [AgentAvailabilityStatus.OFFLINE]: 'Offline',
  [AgentAvailabilityStatus.ON_CALL]: 'On Call',
  [AgentAvailabilityStatus.DISABLED]: 'Disabled',
};